module.exports = __webpack_public_path__ + "img/Penny-Pinch-01.de1cb2c6.jpg";